export default __webpack_public_path__ + "locales/it/Translations.json?hash=af2053c270dc10570d86b963783efe34";